import { ExpertAdvice } from "@/common/api.service";
import { FETCH_SUBMITTED } from "./actions.type";

import { FETCH_SUBMITTED_END, FETCH_SUBMITTED_START } from "./mutations.type";

const state = {
  submittedProjects: {
    counts: 0,
    items: []
  },
  iSubmittedProjectsLoading: true
};

const getters = {
  submittedProjects(state) {
    return state.submittedProjects;
  },
  iSubmittedProjectsLoading(state) {
    return state.iSubmittedProjectsLoading;
  }
};

const actions = {
  [FETCH_SUBMITTED]({ commit }, params) {
    commit(FETCH_SUBMITTED_START);
    return ExpertAdvice.getListSubmitted(params.type, params)
      .then(({ data }) => {
        commit(FETCH_SUBMITTED_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};

const mutations = {
  [FETCH_SUBMITTED_START](state) {
    state.iSubmittedProjectsLoading = true;
  },
  [FETCH_SUBMITTED_END](state, projects) {
    state.submittedProjects = projects;
    state.iSubmittedProjectsLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
